import React from 'react';
import { Typography } from 'Components/atoms';
import { DropdownComponent } from 'Components/molecules';
import { TRAINING_DUE_IN_DAYS_OPTIONS, TRAINING_DUE_IN_DAYS_PLACEHOLDER } from 'Core-utils/constants/constants';
import './styles.scss';

type TrainingDueInDaysFieldProps = {
    value: string;
    onChange: (days: string) => void;
    disabled?: boolean;
    className?: string;
};

export const TrainingDueInDaysField: React.FC<TrainingDueInDaysFieldProps> = ({
    value,
    onChange,
    disabled = false,
    className,
}) => (
    <div className={`training-due-in-days-field ${className ?? ''}`.trim()}>
        <Typography variant="body4" color="text-high-emphasis" className="training-due-in-days-field__label">
            Training is Overdue if NOT completed within
        </Typography>
        <div className="training-due-in-days-field__dropdown">
            <DropdownComponent
                value={value}
                dropDownItems={TRAINING_DUE_IN_DAYS_OPTIONS}
                variant="filled"
                placeholder={TRAINING_DUE_IN_DAYS_PLACEHOLDER}
                onChange={(val) => onChange(val ?? '')}
                disableToggle={disabled}
                maxWidth="100%"
            />
        </div>
        <Typography variant="body4" color="text-high-emphasis" className="training-due-in-days-field__label">
            days.
        </Typography>
    </div>
);
